import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles are added here

const TicketTypes = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketTypes, setTicketTypes] = useState([
    { ticketType: "Local", status: "Active", id: 1 },
    { ticketType: "Foreign", status: "Inactive", id: 2 },
    { ticketType: "SAARC", status: "Active", id: 3 },
    { ticketType: "Non-SAARC", status: "Active", id: 4 },
  ]);

  const [formData, setFormData] = useState({
    ticketType: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [ticketTypes]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedTicket) {
      setTicketTypes(
        ticketTypes.map((ticket) =>
          ticket.id === selectedTicket.id ? { ...formData, id: ticket.id } : ticket
        )
      );
    } else {
      setTicketTypes([
        ...ticketTypes,
        { ...formData, id: ticketTypes.length ? ticketTypes[ticketTypes.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ ticketType: "", status: "Active" });
    setSelectedTicket(null);
  };

  const handleEdit = (ticket) => {
    setSelectedTicket(ticket);
    setFormData({ ticketType: ticket.ticketType, status: ticket.status });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedTicket(null);
    setFormData({ ticketType: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="ticket-type-page d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Box */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedTicket ? "Edit Ticket Type" : "Add Ticket Type"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Ticket Type:</label>
              <input
                type="text"
                name="ticketType"
                value={formData.ticketType}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">Save</button>
            <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right-side Table */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Ticket Types</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Ticket Type
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Ticket Type</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ticketTypes.map((ticket) => (
                  <tr key={ticket.id}>
                    <td>{ticket.ticketType}</td>
                    <td>
                      <span className={`badge ${ticket.status === "Active" ? "bg-success" : "bg-danger"}`}>
                        {ticket.status}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={() => handleEdit(ticket)}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketTypes;
